import { api } from '@/core/api/'

const apiUrl = 'api/edenchildcount'

export default {
  getReportAvailableAcademicYears() {
    return api.get(`${apiUrl}/reportavailableacademicyears`)
  },
  getDetail(edenMasterId) {
    return api.get(`${apiUrl}/detail?edenChildCountId=${edenMasterId}`)
  },
  searchDetail(params) {
    return api.post(`${apiUrl}/searchdetail`, params)
  },
  deleteFiles(edenMasterId) {
    return api.delete(`${apiUrl}/files/delete/${edenMasterId}`)
  },
  getAvailableAcademicYears() {
    return api.get(`${apiUrl}/availableAcademicYears`)
  },
  getEdenChildCount(params) {
    return api.get(`${apiUrl}/edenchildcount`, { params: params })
  },
  createEdenChildCountReport(academicYearId) {
    return api.post(`${apiUrl}/createedenchildcountreport/${academicYearId}`)
  },
  updateEdenChildCountReport(id) {
    return api.put(`${apiUrl}/updateedenchildcountreport/${id}`)
  },
  generateFiles(edenMasterId) {
    return api.post(`${apiUrl}/generatefiles/${edenMasterId}`)
  },
  getFiles(edenMasterId) {
    return api.get(`${apiUrl}/files/${edenMasterId}`)
  },
  getFile(edenFileId) {
    return api.get(`${apiUrl}/file/${edenFileId}`)
  },
  submitReport(params) {
    return api.put(`${apiUrl}/submitmaster`, params)
  },
  amendReport(params) {
    return api.post(`${apiUrl}/amendReport`, params)
  },
  publishPublicPortalData(edenMasterId) {
    return api.post(`${apiUrl}/publishpublicportaldata/${edenMasterId}`)
  },
}
